import React from "react";
import { object, bool, number, string } from "prop-types";

import { Link } from "@quintype/components";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card7.m.css";

const StoryCard7 = ({ story, headerType, headerLevel, lineClamp = 3 }) => {
  return (
    <div className="story-card story-card-7" styleName="story-card-7" id="story-card-7">
      <Link href={`/${story.slug}`}>
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          lineClamp={lineClamp}
        />
        <span styleName="summary" className="hide-mobile summary line-clamp-3">
          {story?.subheadline
            ? story?.subheadline
            : story.seo && story.seo["meta-description"]
              ? story.seo["meta-description"]
              : null}
        </span>
        <StoryDate story={story} />
      </Link>
    </div>
  );
};

StoryCard7.defaultProps = {
  headerType: 4,
  headerLevel: 1,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard7.propTypes = {
  story: object.isRequired,
  headerType: number,
  headerLevel: number,
  showSummary: bool,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard7;
